import { cn } from '../lib/cn.ts';
import { MOD_LABEL, isMac } from '../lib/platform.ts';
import { Kbd as KbdPrimitive } from '../primitives/kbd.tsx';

const KEY_LABEL: Record<string, string> = {
  mod: MOD_LABEL,
  shift: isMac ? '⇧' : 'Shift',
  alt: isMac ? '⌥' : 'Alt',
  enter: '↵',
  esc: 'Esc',
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
  backspace: '⌫',
};

export interface KbdProps {
  /** Keys pressed together, for example ['mod', 'k']. 'mod' renders as the command symbol or Ctrl. */
  keys: string[];
  /** Keys pressed one after the other (g then s). */
  then?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export function keyLabel(k: string): string {
  return KEY_LABEL[k.toLowerCase()] ?? (k.length === 1 ? k.toUpperCase() : k);
}

/** Keyboard keys, for shortcut hints in tooltips, menus and buttons. Each key is the shadcn Kbd: 12 px, weight 500. */
export function Kbd({ keys, then, size = 'sm', className }: KbdProps) {
  return (
    <span className={cn('inline-flex items-center gap-0.5 align-middle', className)}>
      {keys.map((k, i) => (
        <span key={`${k}-${i}`} className="inline-flex items-center gap-0.5">
          {then && i > 0 && <span className="px-0.5 text-caption text-fg-subtle">then</span>}
          <KbdPrimitive className={cn(size === 'md' && 'h-6 min-w-6 px-1.5')}>{keyLabel(k)}</KbdPrimitive>
        </span>
      ))}
    </span>
  );
}
